import { useRef } from "react";
import classnames from "classnames";
import DefaultSelect from "../DefaultSelect";
import { TooltipContainer } from "@outplayed/tooltips";
import { useTranslation } from "react-i18next";
import { normalizeRole, getRoleSVG } from "@ugg/shared/utils/role-helpers";
import { FILTER_IS_NOT_DEFAULT_CLASSNAME } from "../FilterManager";
import { FilterSelect, FilterOption } from "@ugg/shared/interfaces/filter-manager.interface";

interface DuoRoleProps extends FilterSelect {
  className?: string;
  options: FilterOption[];
  disableTooltip?: boolean;
  isMobile?: boolean;
}

export default function DuoRole(props: DuoRoleProps) {
  const tooltipRef = useRef<{ forceClose: Function }>({ forceClose: () => {} });
  const { t } = useTranslation();
  const { className, filters, options, isDefault, onFilterChange, isMobile, disableTooltip } = props;

  const formatOptionLabel = ({ value, label }: (typeof options)[number]) => {
    const pair = value.split("_");
    const role1 = normalizeRole(pair[0]);
    const role2 = normalizeRole(pair[1]);

    return (
      <div className="duo-role-option">
        {getRoleSVG(role1)}
        <span className="mx-[10px] text-[20px] font-normal text-lavender-300">/</span>
        {getRoleSVG(role2)}
      </div>
    );
  };

  return (
    <TooltipContainer
      ref={tooltipRef}
      tooltipInfo={t("Change Duo Roles")}
      customClassName={className}
      disableTooltip={isMobile || disableTooltip}
    >
      <div>
        <DefaultSelect
          className={classnames("filter-select", {
            [FILTER_IS_NOT_DEFAULT_CLASSNAME]: typeof isDefault === "boolean" ? !isDefault : !isDefault?.("duo"),
          })}
          options={options}
          onChange={(selected) => {
            onFilterChange("duo", selected);
          }}
          value={filters.duo}
          formatOptionLabel={formatOptionLabel}
          isSearchable={false}
          width={110}
          onMenuClose={() => tooltipRef.current.forceClose()}
        />
      </div>
    </TooltipContainer>
  );
}
